async function writeTo(working, command, p) {
  let varArg = command.getArg("var");
  working.vars.set(varArg, working.text);
  return working.text;
}
writeTo.key = "write-to";
writeTo.title = "Write To Variable";
writeTo.category = "Variables";
writeTo.docUrl = "https://deanebarker.net/tech/code/textflow-js/commands/write-to/";
writeTo.description = "Write the current text to a variable.";
writeTo.args = [
  { name: "var", type: "string", description: "The variable name to write to." },
];
writeTo.parseValidators = [
  {
    test: (command) => {
      return command.hasArg("var") && typeof command.getArg("var") === "string";
    },
    message:
      "You must provide a 'var' argument with a variable name.",
  },
];

export default writeTo;
